"use client";

import { JusticeScale01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cn } from "../../utils";
import ControlIcon from "./ControlIcon";
import type { ControlProps } from "./IconContainer";

type Props = ControlProps & {
  label: string;
};

export function GameControlsFairness({ label, className, ...props }: Props) {
  return (
    <button
      type="button"
      className={cn(
        "flex h-8 items-center gap-1.5 rounded-full px-2.5",
        "bg-background border border-border",
        "text-sm font-medium whitespace-nowrap text-foreground",
        "outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
        className,
      )}
      {...props}
    >
      <ControlIcon icon={JusticeScale01Icon} />
      {label}
    </button>
  );
}
